import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/sIcon.png'
import _imports_1 from '@/assets/uIcon.png'
import _imports_2 from '@/assets/float.png'


const _withScopeId = n => (_pushScopeId("data-v-c784a306"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["data-departmentid", "data-businessday"]
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-md-5" }
const _hoisted_4 = {
  key: 0,
  class: "col-md-2 buttonGroup"
}
const _hoisted_5 = {
  title: "Selected Date",
  id: "btnSelectedDate",
  style: {}
}
const _hoisted_6 = { class: "col" }
const _hoisted_7 = { class: "float-end" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_9 = {
  key: 0,
  class: "dailyroster-skills-census-summaries"
}
const _hoisted_10 = { class: "table-responsive" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, "Compressed View", -1))
const _hoisted_12 = { class: "table table-bordered dailyRostersummaries-skill-grid daily-roster-compressed-print" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, null, -1))
const _hoisted_14 = { class: "dr-date-row dr-heading" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "leading-cell" }, "Date", -1))
const _hoisted_16 = { class: "dr-start-time-row dr-heading" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "leading-cell" }, " Start Time", -1))
const _hoisted_18 = { class: "dr-end-time-row dr-heading" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "leading-cell" }, " End Time", -1))
const _hoisted_20 = { class: "dr-staffto-row dr-heading" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "leading-cell" }, " StaffTo", -1))
const _hoisted_22 = { class: "dr-actualcensus-row dr-heading" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "leading-cell" }, " Actual Census", -1))
const _hoisted_24 = { class: "dr-forecast-census dr-heading" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "leading-cell" }, " Forecast Census", -1))
const _hoisted_26 = { class: "dr-skills-heading dr-heading" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "leading-cell" }, " Skills", -1))
const _hoisted_28 = ["data-departmentsummaryid"]
const _hoisted_29 = ["data-departmentsummaryid"]
const _hoisted_30 = ["data-departmentsummaryid"]
const _hoisted_31 = {
  key: 1,
  class: "dailyroster-skills-census-summaries"
}
const _hoisted_32 = { class: "row" }
const _hoisted_33 = { class: "col" }
const _hoisted_34 = { class: "dailyRoster-assignments-grid" }
const _hoisted_35 = {
  color: "plain-0",
  class: "p-0 m-0"
}
const _hoisted_36 = { class: "neutable daily-roster-compressed-print" }
const _hoisted_37 = { align: "left" }
const _hoisted_38 = ["slot", "onClick"]
const _hoisted_39 = ["title"]
const _hoisted_40 = { key: 0 }
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_42 = { style: {"text-decoration":"line-through"} }
const _hoisted_43 = { key: 1 }
const _hoisted_44 = ["title"]
const _hoisted_45 = { key: 0 }
const _hoisted_46 = { key: 1 }
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "associaionIcon",
  title: "Secondary Association"
}, null, -1))
const _hoisted_48 = [
  _hoisted_47
]
const _hoisted_49 = { key: 2 }
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  class: "associaionIcon",
  title: "Unassociated"
}, null, -1))
const _hoisted_51 = [
  _hoisted_50
]
const _hoisted_52 = { key: 3 }
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "associaionIcon",
  src: _imports_2,
  alt: "Float"
}, null, -1))
const _hoisted_54 = [
  _hoisted_53
]
const _hoisted_55 = ["title"]
const _hoisted_56 = ["title"]
const _hoisted_57 = ["title"]
const _hoisted_58 = ["title"]
const _hoisted_59 = ["title"]
const _hoisted_60 = ["title", "onClick"]
const _hoisted_61 = { class: "notes-col" }
const _hoisted_62 = { key: 0 }
const _hoisted_63 = { class: "tooltiptext" }
const _hoisted_64 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_65 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_66 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_PlusMetricsReport = _resolveComponent("PlusMetricsReport")!
  const _component_ClockInsReport = _resolveComponent("ClockInsReport")!
  const _component_EditAssignment = _resolveComponent("EditAssignment")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dailyRosterCompressedReportInput, (data, index) => {
      return (_openBlock(), _createElementBlock("div", { key: data }, [
        _createElementVNode("div", {
          class: "dailyRosterDetail-card p-2 mb-2",
          style: {"background-color":"white"},
          "data-departmentid": data.departmentId,
          "data-businessday": _ctx.GetBusinessDay(data.businessDay)
        }, [
          _createElementVNode("div", {
            class: _normalizeClass(['heading ', index != 0 ? 'dailyRoasterPrintPageBreak': ''])
          }, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("h5", null, _toDisplayString('(' + data.facilityCoId + ') ' + data.facilityName), 1)
              ]),
              (index == 0 && data.summaries != null && data.summaries.length > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                    _createElementVNode("button", {
                      title: "Previous Date",
                      id: "btnPreviousDate",
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.onDayClick(false)))
                    }, _toDisplayString('<')),
                    _createElementVNode("button", _hoisted_5, _toDisplayString((data.summaries != null && data.summaries.length > 0) ? _ctx.GetSummarySectionDate(data.summaries[0].startDateTime) : ''), 1),
                    _createElementVNode("button", {
                      title: "Next Date",
                      id: "btnNextDate",
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onDayClick(true)))
                    }, _toDisplayString('>'))
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("h5", _hoisted_7, _toDisplayString('(' + data.departmentCode + ') ' + data.departmentName), 1)
              ])
            ])
          ], 2),
          _hoisted_8,
          (data.summaries != null && data.summaries.length > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  _hoisted_11,
                  _createElementVNode("table", _hoisted_12, [
                    _hoisted_13,
                    _createElementVNode("tbody", null, [
                      _createElementVNode("tr", _hoisted_14, [
                        _hoisted_15,
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.summaries, (dataItemDate) => {
                          return (_openBlock(), _createElementBlock("td", {
                            key: dataItemDate,
                            class: "NumColum",
                            colspan: "3"
                          }, _toDisplayString(_ctx.GetSummarySectionDate(dataItemDate.startDateTime)), 1))
                        }), 128))
                      ]),
                      _createElementVNode("tr", _hoisted_16, [
                        _hoisted_17,
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.summaries, (dataItemSTime) => {
                          return (_openBlock(), _createElementBlock("td", {
                            key: dataItemSTime,
                            class: "NumColum",
                            colspan: "3"
                          }, _toDisplayString(_ctx.AssignmentStartTime(dataItemSTime.startDateTime)), 1))
                        }), 128))
                      ]),
                      _createElementVNode("tr", _hoisted_18, [
                        _hoisted_19,
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.summaries, (dataItemETime) => {
                          return (_openBlock(), _createElementBlock("td", {
                            key: dataItemETime,
                            class: "NumColum",
                            colspan: "3"
                          }, _toDisplayString(_ctx.AssignmentEndTime(dataItemETime.endDateTime)), 1))
                        }), 128))
                      ]),
                      _createElementVNode("tr", _hoisted_20, [
                        _hoisted_21,
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.summaries, (dataItemStaffTo) => {
                          return (_openBlock(), _createElementBlock("td", {
                            key: dataItemStaffTo,
                            class: "NumColum",
                            colspan: "3"
                          }, _toDisplayString(Number(dataItemStaffTo.staffTo) ? dataItemStaffTo.staffTo : '-'), 1))
                        }), 128))
                      ]),
                      _createElementVNode("tr", _hoisted_22, [
                        _hoisted_23,
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.summaries, (dataItemActualCensus) => {
                          return (_openBlock(), _createElementBlock("td", {
                            key: dataItemActualCensus,
                            class: "NumColum",
                            colspan: "3"
                          }, _toDisplayString(Number(dataItemActualCensus.actualCensus) ? dataItemActualCensus.actualCensus : '-'), 1))
                        }), 128))
                      ]),
                      _createElementVNode("tr", _hoisted_24, [
                        _hoisted_25,
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.summaries, (dataItemForecastCesus) => {
                          return (_openBlock(), _createElementBlock("td", {
                            key: dataItemForecastCesus,
                            class: "NumColum",
                            colspan: "3"
                          }, _toDisplayString(Number(dataItemForecastCesus.forecastCensus) ? dataItemForecastCesus.forecastCensus : '-'), 1))
                        }), 128))
                      ]),
                      _createElementVNode("tr", _hoisted_26, [
                        _hoisted_27,
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.summaries, (dataItemSkill) => {
                          return (_openBlock(), _createElementBlock(_Fragment, { key: dataItemSkill }, [
                            _createElementVNode("td", {
                              class: "NumColum",
                              "data-departmentsummaryid": dataItemSkill.departmentSummaryId,
                              "data-skillsummarytype": "scheduled"
                            }, "S", 8, _hoisted_28),
                            _createElementVNode("td", {
                              class: "NumColum",
                              "data-departmentsummaryid": dataItemSkill.departmentSummaryId,
                              "data-skillsummarytype": "target"
                            }, "T", 8, _hoisted_29),
                            _createElementVNode("td", {
                              class: "NumColum",
                              "data-departmentsummaryid": dataItemSkill.departmentSummaryId,
                              "data-skillsummarytype": "difference"
                            }, "D", 8, _hoisted_30)
                          ], 64))
                        }), 128))
                      ]),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.GetDailyRostersummariesSkills(data.summaries), (dataItemSkillLevel, arrIndex) => {
                        return (_openBlock(), _createElementBlock("tr", {
                          class: "skill-row",
                          key: dataItemSkillLevel
                        }, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(dataItemSkillLevel, (dataItemSkillLevelDetails, index) => {
                            return (_openBlock(), _createElementBlock(_Fragment, { key: dataItemSkillLevelDetails }, [
                              (((index % 3 == 0) && index != 0))
                                ? (_openBlock(), _createElementBlock("td", {
                                    key: 0,
                                    class: _normalizeClass(['NumColum', arrIndex == _ctx.GetDailyRostersummariesSkills(data.summaries).length - 1 ? 'font-weight-bold' : '' ,
                                                     dataItemSkillLevelDetails < 0 ? 'gridUnderStaff' : dataItemSkillLevelDetails > 0 ? 'gridOverStaff' : ''])
                                  }, _toDisplayString(dataItemSkillLevelDetails), 3))
                                : (_openBlock(), _createElementBlock("td", {
                                    key: 1,
                                    class: _normalizeClass([index != 0 ? 'NumColum' : '',
                                                    arrIndex == _ctx.GetDailyRostersummariesSkills(data.summaries).length - 1 ? 'font-weight-bold' : ''])
                                  }, _toDisplayString(dataItemSkillLevelDetails), 3))
                            ], 64))
                          }), 128))
                        ]))
                      }), 128))
                    ])
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          (data.assignments != null && data.assignments.length > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                _createElementVNode("div", _hoisted_32, [
                  _createElementVNode("div", _hoisted_33, [
                    _createElementVNode("div", _hoisted_34, [
                      _createElementVNode("div", _hoisted_35, [
                        _createElementVNode("table", _hoisted_36, [
                          _createElementVNode("colgroup", null, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Object.keys(_ctx.columnHeaders), (column) => {
                              return (_openBlock(), _createElementBlock("col", {
                                key: column,
                                style: _normalizeStyle({'width': _ctx.columnHeaders[column] })
                              }, null, 4))
                            }), 128))
                          ]),
                          _createElementVNode("thead", null, [
                            _createElementVNode("tr", null, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Object.keys(_ctx.columnHeaders), (column) => {
                                return (_openBlock(), _createElementBlock("th", { key: column }, _toDisplayString(column), 1))
                              }), 128))
                            ])
                          ]),
                          _createElementVNode("tbody", _hoisted_37, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.assignments, (dataItem) => {
                              return (_openBlock(), _createElementBlock("tr", {
                                slot: _ctx.column,
                                key: dataItem,
                                class: _normalizeClass([_ctx.getAssignmentClassForRow(dataItem), "pointer"]),
                                onClick: ($event: any) => (_ctx.onEditingShift(dataItem))
                              }, [
                                _createElementVNode("td", {
                                  title: dataItem.departmentCode,
                                  class: "department-col"
                                }, [
                                  (dataItem.origDeptId !== dataItem.departmentId)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_40, [
                                        _createTextVNode(_toDisplayString(dataItem.departmentCode) + " ", 1),
                                        _hoisted_41,
                                        _createElementVNode("span", _hoisted_42, _toDisplayString(dataItem.origDepartmentCode), 1)
                                      ]))
                                    : (_openBlock(), _createElementBlock("span", _hoisted_43, _toDisplayString(dataItem.departmentCode), 1))
                                ], 8, _hoisted_39),
                                _createElementVNode("td", {
                                  title: dataItem.staffLastName + ' ' + dataItem.staffFirstName,
                                  class: "employee-col"
                                }, [
                                  _createElementVNode("span", {
                                    class: _normalizeClass([(dataItem.origDeptId !== dataItem.departmentId && dataItem.origDeptId === data.departmentId)? 'strikethrough': ''])
                                  }, _toDisplayString(dataItem.staffLastName + ' ' + dataItem.staffFirstName), 3),
                                  (dataItem.charge)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_45, [
                                        _createVNode(_component_font_awesome_icon, {
                                          icon: ['fa', 'user-md'],
                                          size: "sm",
                                          class: "chargeIcon"
                                        })
                                      ]))
                                    : _createCommentVNode("", true),
                                  (dataItem.associationType === _ctx.defaults.secondaryStaff)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_46, _hoisted_48))
                                    : _createCommentVNode("", true),
                                  (dataItem.associationType === _ctx.defaults.unassociatedStaff)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_49, _hoisted_51))
                                    : _createCommentVNode("", true),
                                  (dataItem.float)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_52, _hoisted_54))
                                    : _createCommentVNode("", true)
                                ], 8, _hoisted_44),
                                _createElementVNode("td", {
                                  title: dataItem.credentialsExpiration
                                }, _toDisplayString(dataItem.credentialsExpiration), 9, _hoisted_55),
                                _createElementVNode("td", {
                                  title: dataItem.skillLevelDescription
                                }, [
                                  _createElementVNode("span", {
                                    class: _normalizeClass([(dataItem.origDeptId !== dataItem.departmentId && dataItem.origDeptId === data.departmentId)? 'strikethrough': ''])
                                  }, _toDisplayString(dataItem.skillLevelDescription), 3)
                                ], 8, _hoisted_56),
                                _createElementVNode("td", {
                                  title: dataItem.hours,
                                  class: _normalizeClass([(dataItem.isOvertime && !dataItem.cancel) ? 'hours-col overtime': 'hours-col'])
                                }, _toDisplayString(dataItem.hours), 11, _hoisted_57),
                                _createElementVNode("td", {
                                  title: dataItem.employeeType
                                }, _toDisplayString(dataItem.employeeType), 9, _hoisted_58),
                                _createElementVNode("td", {
                                  title: dataItem.fte
                                }, _toDisplayString(dataItem.fte), 9, _hoisted_59),
                                _createElementVNode("td", {
                                  title: dataItem.shiftCode,
                                  onClick: ($event: any) => (_ctx.onEditingShift(dataItem)),
                                  class: _normalizeClass([(dataItem.overtimeShift && !dataItem.cancel) ? 'shift-col overtime': 'shift-col'])
                                }, _toDisplayString(dataItem.shiftCode), 11, _hoisted_60),
                                _createElementVNode("td", _hoisted_61, [
                                  (dataItem.hasNotes)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_62, [
                                        _createElementVNode("span", {
                                          class: "tooltip",
                                          onMouseover: _cache[2] || (_cache[2] = ($event: any) => (_ctx.showToolTip($event)))
                                        }, [
                                          _createVNode(_component_font_awesome_icon, {
                                            icon: ['fa', 'sticky-note'],
                                            size: "sm",
                                            onClick: ($event: any) => (_ctx.onEditingShift(dataItem))
                                          }, null, 8, ["onClick"]),
                                          _createElementVNode("span", _hoisted_63, [
                                            _createTextVNode("Notes: "),
                                            _hoisted_64,
                                            _createTextVNode(" " + _toDisplayString(_ctx.setGridDateFormat(dataItem.notedate)) + " ", 1),
                                            _hoisted_65,
                                            _createTextVNode(" " + _toDisplayString(dataItem.note.length > 50 ? dataItem.note.replace(' ','').substring(0,50) + "..." : dataItem.note), 1)
                                          ])
                                        ], 32)
                                      ]))
                                    : _createCommentVNode("", true)
                                ])
                              ], 10, _hoisted_38))
                            }), 128))
                          ])
                        ])
                      ])
                    ])
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          _hoisted_66,
          (data.plusMetrics != null)
            ? (_openBlock(), _createBlock(_component_PlusMetricsReport, {
                key: 2,
                plusMetricsReportInput: data.plusMetrics,
                facilityName: data.facilityName,
                departmentName: data.departmentName
              }, null, 8, ["plusMetricsReportInput", "facilityName", "departmentName"]))
            : _createCommentVNode("", true),
          (data.clockIns != null && data.clockIns.shiftClockIns != null && data.clockIns.shiftClockIns.length > 0)
            ? (_openBlock(), _createBlock(_component_ClockInsReport, {
                key: 3,
                clockInsInput: data.clockIns
              }, null, 8, ["clockInsInput"]))
            : _createCommentVNode("", true)
        ], 8, _hoisted_1)
      ]))
    }), 128)),
    (_ctx.isEditAssignment)
      ? (_openBlock(), _createBlock(_component_EditAssignment, {
          key: 0,
          assignmentInput: _ctx.assignmentInput,
          assignmentType: _ctx.assignmentType,
          onCloseModal: _ctx.closeEditAssignment
        }, null, 8, ["assignmentInput", "assignmentType", "onCloseModal"]))
      : _createCommentVNode("", true)
  ], 64))
}